/**
 * The one contract shared by the import entry point and the route that hosts
 * the page — kept in a single place so the button and the route guard can't
 * drift apart.
 */

/** Geoset import shares the geofence create permission. */
export const GEOSET_IMPORT_PERMISSION = 'journeys/geofences/create';

/** TanStack route path of the import page. */
export const GEOSET_IMPORT_ROUTE = '/workspaces/$workspaceId/geosets/import';
